module.exports = __webpack_public_path__ + "img/Airport.b7be92bc.jpg";